import { IGetAllContasReceberParcialUseCase } from "../../../presentation/useCases/read/get_all_contas_receber_parcial_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";
import { ContasReceberParcial } from "../../models/recebimento_parcial";

/**
 * GetAllContasReceberParcialUseCase
 */

export class GetAllContasReceberParcialUseCase
  extends BasePaginatedUseCase<ContasReceberParcial>
  implements IGetAllContasReceberParcialUseCase {
  constructor(private readonly repository: IFinanceiroRepository) {
    super();
  }

  async getAllContasReceberParcial(
    idContasReceber: number,
    page: number,
    rowsPerPage: number): Promise<void> {

    const result = await this.repository.getAllContasReceberParcial(idContasReceber, page, rowsPerPage);
    this._items = result.items;
    this._currentPage = result.currentPage;
    this._pageSize = result.pageSize;
    this._totalItems = result.totalItems;
    this._totalPages = result.totalPages;
  }
}
